import type { FunctionComponent } from 'react';
import { LocationPageTitle } from '../../../components/LocationPageTitle/LocationPageTitle';
import { useStreetPageQuery } from '../../graphql/useStreetPageQuery';

export const StreetPageTitleWithData: FunctionComponent = () => {
  const titleParts = useStreetPageQuery()?.data?.streetPageBySlug?.title?.parts;
  if (!titleParts) return null;

  const [overline, title, subtitle] = titleParts;
  if (!overline || !title) return null;

  return <LocationPageTitle overline={overline} title={title} subtitle={subtitle} />;
};
